export const POST_DELETE_RESET = 'POST_DELETE_RESET'
export const POST_DELETE_SET_ERROR = 'POST_DELETE_SET_ERROR'
export const POST_DELETE_SET_DELETED = 'POST_DELETE_SET_DELETED'
export const POST_DELETE_TOGGLE_LOADING = 'POST_DELETE_TOGGLE_LOADING'
